var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-179 373.1 54.3 50",
    style: {
      enableBackground: "new -179 373.1 54.3 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#02723B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -140.4,
    y: 393.4,
    className: "st0",
    width: 6.1,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -140.4,
    y: 388.9,
    className: "st0",
    width: 6.1,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -140.4,
    y: 398,
    className: "st0",
    width: 6.1,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -140.4,
    y: 402.5,
    className: "st0",
    width: 6.1,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -140.4,
    y: 407.1,
    className: "st0",
    width: 6.1,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-130.8,384.8h-14.7v-4.1l-22.3,3.9v30.2l22.3,3.8V414h14.7c0.6,0,1-0.5,1-1v-27.2 C-129.8,385.3-130.2,384.8-130.8,384.8z M-155.2,406.4c0,0-2.1-5.4-2.1-5.5h-0.1c0,0.1-2.1,5.2-2.1,5.2l-2.8-0.2l3.3-6.5l-3-6.5 l2.8-0.2c0,0,1.9,5,1.9,5.1h0.1c0-0.1,2.1-5.3,2.1-5.3l2.9-0.2l-3.5,7.1l3.6,7.1L-155.2,406.4z M-131.1,412.9h-14.4v-2.8h3.5v-3 h-3.5v-1.5h3.5v-3h-3.5v-1.5h3.5v-3h-3.5v-1.5h3.5v-3h-3.5v-1.5h3.5v-3h-3.5v-3h14.4V412.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.f90666067ce2dd05b5a53273b33b6fbd.svg";
export { ForwardRef as ReactComponent };